import React, { useEffect, useMemo, useState } from 'react'
import { GridSemaforoPure, SimpleLoading } from '../../pures'
import { Grid } from '@material-ui/core'
import { ButtonHLPure } from '../../pures'
import { Dialog } from '@progress/kendo-react-dialogs'
import PdfReader from '../../pures/adobePfdReader/PdfReader'

const RepseStatusByCompanyDocumentsView = (props) => {
  const [showDetails, setShowDetails] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [pdfUrl, setPdfUrl] = useState("");
  const [dialogLoading, setDialogLoading] = useState(false);

  const onViewDetails = (document) => {
    setShowDetails(true);
    setSelectedDocument(document);
  }

  const onCloseDetails = () => {
    setShowDetails(false);
    setSelectedDocument(null);
    setPdfUrl("");
  }

  useEffect(() => {
    if (!selectedDocument) return;

    const getDocumentUrl = async () => {
      setDialogLoading(true);

      try {
        let response = await props.getDocumentUrl(selectedDocument.filePath);
        if (response.statusCode != 200) throw new Error("Error obteniendo archivo")

        setPdfUrl(response.data);
      } catch (e) {
        setPdfUrl("");
      }

      setDialogLoading(false);
    }

    getDocumentUrl();
  }, [selectedDocument])


  return (
    <>
      <div className='fadeIn'>
        <GridSemaforoPure
          columnTitle={"Documento"}
          dataItems={props.documents}
          getColorByStatus={(status) => props.getColorByStatus(status)}
          statusFieldName={"statusDocument"}
          onSemaforoClick={onViewDetails}
          yearShown={props.yearShown}
          onMonthSelected={props.onMonthSelected}
        />
        <Grid
          container
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
          className="repseStatusByCompany-actionsContainer"
        >
          <div className='justify-right'>
            <ButtonHLPure
              nameBtn="Regresar"
              onClickBtn={props.onBack} />
          </div>
        </Grid>
      </div>
      {
        showDetails &&
        <Dialog title={`${selectedDocument.clientDocument.name}`} onClose={onCloseDetails} height={500} width={750}>
          {
            dialogLoading
              ? <SimpleLoading />
              : <PdfReader className="pdfReader" url={pdfUrl} awsURL src={pdfUrl} />
          }
        </Dialog>
      }
    </>
  )
}

export default RepseStatusByCompanyDocumentsView;
